<template>
    <v-container fluid>
        <v-card>
            <v-card-title class="pb-0">
                <span class="profile-title">Profile</span>
            </v-card-title>

            <v-container fluid>
                <v-col :cols="6" class="pl-0 pt-0">
                    <v-progress-circular v-if="isLoading" :size="40" :width="7" indeterminate color="tertiary" />
                    <v-form ref="editForm" v-if="!isLoading" :key="formKey">
                        <v-card>
                            <v-card-text>
                                <v-text-field v-model="item.exemplarGlobalNumber" label="Exemplar Global Number" readonly />
                                <contact-fields v-model="item.contact" :remove-email-address="true" :contact-id="item.contactId" :rules="contactRules" />
                            </v-card-text>
                            <v-card-actions>
                                <div class="flex-grow-1"></div>
                                <v-btn color="quaternary" text @click="load">Cancel</v-btn>
                                <v-btn color="quaternary" text @click="save">Save</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-form>
                    </v-col>
            </v-container>
        </v-card>
    </v-container>
</template>

<script>
    import axios from 'axios'
    import securityService from '../services/securityService'
    import errorUtility from '../services/errorUtility'

    export default {
        props: [
            'showExpand'
        ],
        components: {
            contactFields: () => import('../components/ContactFields')
        },
        data() {
            return {
                item: null,
                isLoading: true,
                isSaving: false,
                formKey: 0,
                contactRules: { name: v => !!v || 'Name is required', emailAddress: v => !!v || 'Email is required' },
            }
        },
        mounted() {
            this.load()
        },
        methods: {
            async load() {
                var auditorId = securityService.getAuditorId();
                var response = await axios.get('/api/Auditors/' + auditorId);
                this.formKey++;
                this.item = response.data;
                this.isLoading = false;
            },
            async save() {
                if (this.isSaving) { return; }
                if (!this.$refs.editForm.validate()) { return; }
                this.isSaving = true;
                var item = Object.assign({}, this.item);
                this.removeEmptyStringOrObjectsFromArray(item);

                try {
                    var response = await axios.put('/api/Auditors/', item);

                    this.item = response.data;
                    await this.load();
                } catch (error) {
                    this.$emit('open');
                    errorUtility.handleServerError(error);
                }
                this.isSaving = false;
            }
        }
    };
</script>
<style>
    .profile-title {
        font-size: 150%;
    }
</style>
